export default __webpack_public_path__ + "static/media/sport-ctg.f6be5959.webp";